<template>
    <div class="bg-white mt-3 p-3 lifecycle-stages-view activity-type-create col-12">
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-4">
                <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('lifecycle_stage') }}</span>
            </div>
        </div>
        <b-overlay :show="loading" rounded="sm">
            <b-form class="form-sample " @submit.stop.prevent="onSubmit">
                <b-row>
                    <b-col cols="12">
                        <label class="mb-3"><strong>{{ $translate('name') }}</strong><span class="red">*</span></label>
                        <b-form-input type="text" id="input-name" v-model="model.name" required v-custom-validation="$textRequired()"
                            :placeholder="$translate('enter_name')" trim></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="mt-3 d-flex align-items-center">
                        <div class="form-check me-2">
                            <label for="input-is_default" class="form-check-label">
                                <input type="checkbox" id="input-is_default" v-model="model.is_default" name="input-is_default"
                                    :value="1" :unchecked-value="0" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                        <label for="input-is_default" class="ms-2"><strong>{{ $translate('default') }}</strong><span
                                class="red">*</span></label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="my-3">
                        <label class="mb-3"><strong>{{ $translate('description') }}</strong></label>
                        <b-form-input type="text" id="input-description" v-model="model.description"
                            :placeholder="$translate('enter_description')" trim></b-form-input>
                    </b-col>
                </b-row>
                <b-col cols="12" class="mb-2 mt-3 text-center">
                    <b-button class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionCreate && !model.id"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionUpdate && model.id"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button v-if="!!this.model.id && hasPermissionDelete" @click="deleteItem()" class="me-2"
                        variant="delete-button" size="fw">
                        {{ $translate('delete_item') }} </b-button>
                    <b-button variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                        $cancelLabel() }}</b-button>
                </b-col>
            </b-form>
        </b-overlay>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'LifecyleStages-ViewItem',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                name: null,
                is_default: false,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id
        },
        /**
         * True if the user has permission to view but not update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return !!this.model.id
        },
        /**
         * True if the user has permission to update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return !!this.model.id
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            if (!model.description) model.description = '-'
            console.log('model', model)
            const action = model.id ? 'update' : 'create'
            const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
            const path = `lifecycleStage/${action}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit(
                                'success',
                                action,
                                message
                            )
                        })
                        .catch(error => {
                            console.log('error', error)
                            this.$emit('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'lifecycleStage/delete'
            const action = 'delete'
            // Generate and display confirmation prompt
            const title = this.$translate('delete_lifecycle_stages')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = 'Unable to delete Customer Segmnent!'
            const alertMsg = this.$translate('delete_alert')
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                action,
                                alertMsg
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                // this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
        },
    },
}
</script>
<style></style>
